var exports = {
  "MU": "overlayContainer-aThRS",
  "xJ": "sliderContainer-aThRS",
  "hQ": "contentContainer-aThRS",
  "Tg": "textArea-aThRS",
  "DD": "title-aThRS",
  "gy": "fadeInRight-aThRS",
  "VA": "subtitle-aThRS",
  "MY": "page-aThRS",
  "zj": "faded-aThRS",
  "qG": "fadeIn-aThRS",
  "jZ": "slideInDown-aThRS",
  "OY": "slideInUp-aThRS",
  "K0": "slideInLeft-aThRS",
  "xA": "slideInRight-aThRS",
};

module.exports = exports;
